import { createDecorator } from '../../../../platform/instantiation/common/instantiation.js';
const IExtensionBisectService = ( createDecorator('IExtensionBisectService'));
export { IExtensionBisectService };
